import { render, staticRenderFns } from "./role_grant.vue?vue&type=template&id=13da9c32&scoped=true"
import script from "./role_grant.vue?vue&type=script&lang=js"
export * from "./role_grant.vue?vue&type=script&lang=js"
import style0 from "./role_grant.vue?vue&type=style&index=0&id=13da9c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da9c32",
  null
  
)

export default component.exports